<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'blue',
    },
    options: {
      type: Object,
      default: () => ({ defaultPadding: true }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <button
    :disabled="disabled"
    :class="{
      [$style.button]: true,
      [$style.buttonBlue]: theme === 'blue',
      [$style.buttonLightBlue]: theme === 'lightBlue',
      [$style.buttonSlate]: theme === 'slate',
      [$style.buttonWhite]: theme === 'white',
      [$style.buttonRed]: theme === 'red',
      [$style.buttonGreen]: theme === 'green',
      [$style.buttonOrange]: theme === 'orange',
      [$style.defaultPadding]: options.defaultPadding,
    }"
    class="button-text"
    v-on="$listeners">
    <slot />
  </button>
</template>

<style lang="scss" module>
@import '@design';

.button {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.buttonBlue {
  height: 48px;
  color: $white;
  background: $primary-blue;
  border: none;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    cursor: pointer;
    background: $light-gray;
  }

  &:hover:enabled {
    opacity: 0.9;
  }
}

.buttonSlate {
  height: 48px;
  color: $white;
  background: #a3bac0;
  border: none;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    cursor: pointer;
    background: $light-gray;
  }

  &:hover:enabled {
    opacity: 0.9;
  }
}

.buttonLightBlue {
  height: 48px;
  color: $white;
  background: $secondary-light-blue;
  border: none;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    cursor: pointer;
    background: $light-gray;
  }

  &:hover:enabled {
    opacity: 0.9;
  }
}

.buttonGreen {
  height: 48px;
  color: $white;
  background: $secondary-green;
  border: none;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    cursor: pointer;
    background: $light-gray;
  }

  &:hover:enabled {
    opacity: 0.9;
  }
}

.buttonOrange {
  height: 48px;
  color: $white;
  background: $secondary-orange;
  border: none;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    cursor: pointer;
    background: $light-gray;
  }

  &:hover:enabled {
    opacity: 0.9;
  }
}

.buttonWhite {
  height: 48px;
  color: $dark-gray;
  background: $white;
  border: 1px solid $light-gray;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    color: $light-gray;
    cursor: pointer;
    background: $white;
  }

  &:hover:enabled {
    opacity: 0.7;
  }
}

.buttonRed {
  height: 48px;
  color: $white;
  background: $secondary-red;
  border: 1px solid $secondary-red;
  border-radius: 48px;
  transition: background-color 0.3s ease;

  &:disabled {
    cursor: pointer;
    background: $light-gray;
    border: none;
  }

  &:hover:enabled {
    opacity: 0.7;
  }
}

.defaultPadding {
  padding: 12px 24px;
}
</style>
